import { Box, Card } from '@mui/material';
import React from 'react'
import Chart from "react-apexcharts";

const PieChart = ({ series, options, centerText, width = 230 }) => {


    const mergedOptions = {
        ...options,
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: centerText,
                            fontSize: "10px",
                            fontWeight: 400,
                            color: "#333",
                        },
                    },
                },
            },
        },
        legend: {
            position: "bottom",
            labels: {
                colors: "#333",
                useSeriesColors: false,
            },
            fontSize: "10px",
        },
        dataLabels: {
            enabled: false,
        },
    };

    return (
        <Card sx={{ height: "100%", width: '100%', padding: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {/* <Typography variant='h6' fontWeight='bold'>{centerText}</Typography> */}
                <Chart options={mergedOptions} series={series} type="donut" width={width} />
            </Box>
        </Card>
    )
}

export default PieChart
